<template>
  <hm-content title="大区管理" class="partition-management-list">
    <div class="table-panel flex flex-between flex-wrap">
      <div class="mr10">
        <el-button type="primary" size="small" @click="openAddDialog"
          >新增大区</el-button
        >
      </div>
      <div class="flex text-right item-center flex-wrap">
        <el-input
          clearable
          v-model.trim="searchCondition.regionName"
          placeholder="输入大区名称"
          size="small"
          class="ipt mr10"
          style="width: 150px;"
        ></el-input>
        <el-select
          size="small"
          clearable
          placeholder="选择省份"
          v-model="searchCondition.provinceCode"
          filterable
          class="mr10"
          style="width: 150px;"
        >
          <el-option
            v-for="province in provinceList"
            :key="province.value"
            :label="province.label"
            :value="province.value"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          placeholder="启用状态"
          v-model="searchCondition.enabledState"
          filterable
          class="mr10"
          style="width: 120px;"
        >
          <el-option label="启用" value="yes"></el-option>
          <el-option label="禁用" value="no"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="resetSearch">重置</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="regionTable"
        :data="regionList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
          width="60"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="regionName"
          label="大区名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="配置范围"
        >
          <template slot-scope="scope">
            <span>{{ formatProvinceNames(scope.row.provinceCodeList) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="状态"
        >
          <template slot-scope="scope">
            <span class="status success" v-show="scope.row.enabledState === 'yes'">启用</span>
            <span class="status danger" v-show="scope.row.enabledState === 'no'">禁用</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="160">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button type="text" size="small" @click="openEditDialog(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="toggleStatus(scope.row)">{{ scope.row.enabledState === 'yes' ? '禁用' : '启用' }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
      ></el-pagination>
    </div>

    <!-- 新增/编辑弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
      custom-class="common-dialog"
    >
      <el-form label-width="100px" :model="formData" ref="formRef" :rules="formRules" size="small">
        <el-form-item label="大区名称" prop="regionName">
          <el-input
            v-model.trim="formData.regionName"
            placeholder="请输入大区名称"
            maxlength="50"
            style="width: 300px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="启用状态" prop="enabledState">
          <el-switch
            v-model="formData.enabledState"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="启用"
            inactive-text="禁用"
            :active-value="'yes'"
            :inactive-value="'no'"
          ></el-switch>
        </el-form-item>
        <el-form-item label="选择省份" prop="provinceCodeList">
          <el-select
            v-model="formData.provinceCodeList"
            multiple
            placeholder="请选择省份"
            style="width: 300px;"
            filterable
          >
            <el-option
              v-for="province in provinceList"
              :key="province.value"
              :label="province.label"
              :value="province.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="formData.remark"
            placeholder="请输入备注"
            :rows="3"
            maxlength="200"
            style="width: 300px;"
          ></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button @click="submitForm" type="primary" size="small">确定</el-button>
      </template>
    </el-dialog>
  </hm-content>
</template>

<script>
import area from "@/utils/areaNew";

export default {
  components: {},
  data() {
    return {
      regionList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        regionName: "",
        provinceCode: "",
        enabledState: ""
      },
      dialogVisible: false,
      dialogTitle: "新增大区",
      formData: {
        id: "",
        regionName: "",
        enabledState: "yes",
        provinceCodeList: [],
        remark: ""
      },
      formRules: {
        regionName: [
          { required: true, message: "请输入大区名称", trigger: "blur" }
        ],
        provinceCodeList: [
          { required: true, message: "请选择省份", trigger: "change", type: "array", min: 1 }
        ]
      },
      provinceList: area.map(item => ({
        value: item.value,
        label: item.label
      }))
    };
  },
  activated() {
    this.queryList();
  },
  mounted() {
    this.queryList();
  },
  methods: {
    /**
     * 格式化省编码列表为省名称
     */
    formatProvinceNames(provinceCodeList) {
      if (!provinceCodeList || provinceCodeList.length === 0) {
        return "-";
      }
      const names = provinceCodeList.map(code => {
        const province = this.provinceList.find(p => p.value === code);
        return province ? province.label : code;
      });
      return names.join("、");
    },
    /**
     * 查询列表
     */
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        ...this.searchCondition
      };
      // 移除空查询条件
      Object.keys(params).forEach(key => {
        if (params[key] === "" || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      try {
        const { result } = await this.$store.dispatch("storeRegionQueryPageList", params);
        this.regionList = result.records || [];
        this.total = result.total || 0;
      } catch (error) {
        console.error("查询失败:", error);
        this.$message.error("查询失败");
      }
    },
    /**
     * 搜索
     */
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    /**
     * 重置搜索条件
     */
    resetSearch() {
      this.searchCondition = {
        regionName: "",
        provinceCode: "",
        enabledState: ""
      };
      this.currentPage = 1;
      this.queryList();
    },
    /**
     * 分页
     */
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    /**
     * 每页条数变化
     */
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    /**
     * 打开新增弹框
     */
    openAddDialog() {
      this.dialogTitle = "新增大区";
      this.formData = {
        id: "",
        regionName: "",
        enabledState: "yes",
        provinceCodeList: [],
        remark: ""
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    /**
     * 打开编辑弹框
     */
    openEditDialog(row) {
      this.dialogTitle = "编辑大区";
      this.formData = {
        id: row.id,
        regionName: row.regionName,
        enabledState: row.enabledState,
        provinceCodeList: row.provinceCodeList ? [...row.provinceCodeList] : [],
        remark: row.remark || ""
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    /**
     * 提交表单
     */
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return;
        
        const actionName = this.formData.id ? "storeRegionEdit" : "storeRegionAdd";
        const params = { ...this.formData };
        
        try {
          const res = await this.$store.dispatch(actionName, params);
          if (res.code === "0" || res.code === 0) {
            this.$message.success(this.formData.id ? "编辑成功" : "新增成功");
            this.dialogVisible = false;
            this.queryList();
          } else {
            this.$message.error(res.msg || "操作失败");
          }
        } catch (error) {
          console.error("操作失败:", error);
          this.$message.error("操作失败");
        }
      });
    },
    /**
     * 切换启用/禁用状态
     */
    toggleStatus(row) {
      const action = row.enabledState === "yes" ? "禁用" : "启用";
      this.$confirm(`确定要${action}该大区吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const params = {
          id: row.id,
          enabledState: row.enabledState === "yes" ? "no" : "yes"
        };
        try {
          const res = await this.$store.dispatch("storeRegionUpdateStatus", params);
          if (res.code === "0" || res.code === 0) {
            this.$message.success(`${action}成功`);
            this.queryList();
          } else {
            this.$message.error(res.msg || `${action}失败`);
          }
        } catch (error) {
          console.error(`${action}失败:`, error);
          this.$message.error(`${action}失败`);
        }
      }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.partition-management-list {
  .status {
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    &.success {
      background-color: #e7f7e7;
      color: #52c41a;
    }
    &.danger {
      background-color: #fff1f0;
      color: #ff4d4f;
    }
    &.blue {
      background-color: #e6f7ff;
      color: #1890ff;
    }
  }
}

.table-panel {
  font-size: 12px;
  .line {
    color: #dcdfe6;
    margin: 0 5px;
  }
}

.table {
  margin-top: 16px;
}

.hm-pagination {
  margin-top: 16px;
  text-align: right;
}

.blue {
  color: #1890ff;
}

.red {
  color: #ff4d4f;
}

.green {
  color: #52c41a;
}
</style>
